"use client";
import { legacyStorePageCopy } from "@/lib/store-seo";
import { FaqAccordion } from "@/components/store/FaqAccordion";

interface StoreFAQProps {
    storeName: string;
    /** Not read by the component (kept optional so old call sites compile); the store page no longer sends them (audit 2026-10-25 item 11). */
    activeCoupons?: number;
    bestDiscount?: string;
    averageSavings?: string;
    attributes?: Record<string, unknown>;
    faqs?: Array<{ question: string; answer: string }>;
    /** v2 template heading; default stays "{storeName} Discount FAQs". */
    heading?: string;
}

export default function StoreFAQ({ storeName, activeCoupons, bestDiscount, averageSavings, attributes, faqs, heading }: StoreFAQProps) {
    // Use provided FAQs or empty array
    const displayFaqs = faqs || [];

    if (displayFaqs.length === 0) return null;



    return (
        <>
            <section className="mt-8" aria-labelledby="store-faq">
                <h2 id="store-faq" className="text-2xl font-bold mb-6 text-white">{heading ?? legacyStorePageCopy(storeName, "").faqHeading}</h2>
                {/* Replaced list with Accordion for better UX */}
                <FaqAccordion faqs={displayFaqs} />
            </section>

            {/* JSON-LD Schema Injection */}
            {/* JSON-LD Schema removed: managed by parent page */}
        </>
    );
}
